import React from "react";
import About from "../components/About";
import Services from "../components/Services";

const Home = () => {
    return (
        <div id="top"> {/* ID for the top of the page */}
            <div
                className="hero-section"
                style={{
                    textAlign: "center",
                    padding: "40px 0", // Adjust padding if needed
                    backgroundImage: `url(${require("../images/background.jpg")})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "left center",
                    margin: "0", // Remove any top margin
                }}
            >
                <div style={{ textAlign: "center", padding: "20px 0" }}>
                    <img
                        src={require("../images/logo_transparent.png")}
                        alt="Indien Buddy Logo"
                        style={{
                            height: "130px",
                            marginBottom: "0px",
                        }}
                    />
                </div>
                <div
                    style={{
                        fontSize: "2rem",
                        color: "#444444",
                        marginTop: "-10px",
                        textShadow: "1px 1px 5px rgba(0, 0, 0, 0.7)",
                    }}
                >
                    Bringing Smiles Across Miles ❤️
                </div>
            </div>
            <div id="about"
                 style={{
                     marginTop: "0",
                     padding: "10px 0", // Align footer properly
                 }}>
                <About />
            </div>
            <div id="services" className="services-section"
                 style={{
                     marginTop: "0",
                     padding: "10px 0", // Align footer properly
                 }}>
                <Services />
            </div>
        </div>
    );
};

export default Home;
